var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(_vm.to),expression:"to"}],staticClass:"live-program-button",attrs:{"href":_vm.to.el}},[_vm._v("ニコニコQ LIVE 出題予定の番組表")])}
var staticRenderFns = []

export { render, staticRenderFns }